module.exports = new __parcel__URL__("viva-chile.f591260a.jpg").toString();